/* tslint:disable */
/* eslint-disable */
/**
 * Solid Slate
 * Booking, made easy
 *
 * The version of the OpenAPI document: 0.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { UserSignupStats } from './UserSignupStats';
import {
    UserSignupStatsFromJSON,
    UserSignupStatsFromJSONTyped,
    UserSignupStatsToJSON,
    UserSignupStatsToJSONTyped,
} from './UserSignupStats';

/**
 *
 * @export
 * @interface SignupSummary
 */
export interface SignupSummary {
    /**
     *
     * @type {Date}
     * @memberof SignupSummary
     */
    start: Date;
    /**
     *
     * @type {Date}
     * @memberof SignupSummary
     */
    end: Date;
    /**
     *
     * @type {number}
     * @memberof SignupSummary
     */
    startValue: number;
    /**
     *
     * @type {Array<UserSignupStats>}
     * @memberof SignupSummary
     */
    signups: Array<UserSignupStats>;
}

/**
 * Check if a given object implements the SignupSummary interface.
 */
export function instanceOfSignupSummary(value: object): value is SignupSummary {
    if (!('start' in value) || value['start'] === undefined) return false;
    if (!('end' in value) || value['end'] === undefined) return false;
    if (!('startValue' in value) || value['startValue'] === undefined) return false;
    if (!('signups' in value) || value['signups'] === undefined) return false;
    return true;
}

export function SignupSummaryFromJSON(json: any): SignupSummary {
    return SignupSummaryFromJSONTyped(json, false);
}

export function SignupSummaryFromJSONTyped(json: any, ignoreDiscriminator: boolean): SignupSummary {
    if (json == null) {
        return json;
    }
    return {

        'start': (new Date(json['start'])),
        'end': (new Date(json['end'])),
        'startValue': json['start_value'],
        'signups': ((json['signups'] as Array<any>).map(UserSignupStatsFromJSON)),
    };
}

  export function SignupSummaryToJSON(json: any): SignupSummary {
      return SignupSummaryToJSONTyped(json, false);
  }

  export function SignupSummaryToJSONTyped(value?: SignupSummary | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {

        'start': ((value['start']).toISOString().substring(0,10)),
        'end': ((value['end']).toISOString().substring(0,10)),
        'start_value': value['startValue'],
        'signups': ((value['signups'] as Array<any>).map(UserSignupStatsToJSON)),
    };
}
